// Only allow internal paths to prevent open-redirect via ?redirect=https://evil.com
// or protocol-relative URLs (//evil.com).
export const safeRedirectPath = (path: string | undefined): string =>
  path && path.startsWith("/") && !path.startsWith("//") ? path : "/";
